import { api } from "lib/graphql/api"
import { query } from "lib/graphql/query"
import { gql } from "@apollo/client"

export const getAssetCount = api(async function getAssetCount(registerId) {
    return query(
        gql`
            query GetAssetCount($registerId: String!) {
                getAssetCount(registerId: $registerId)
            }
        `,
        {
            registerId,
        },
        {
            returns: "getAssetCount",
        }
    )
})
